import { getMe } from '@/features/auth/api/auth'
import { queryClient } from '@/lib/api/queryClient'
import { useAuthStore } from '@/stores/auth'

export const CURRENT_USER_QUERY_KEY = ['auth', 'me'] as const

/**
 * Refreshes the signed-in user (roles included) from the backend once per page load, so a
 * persisted session picks up role changes. The router guard awaits it before system-admin pages.
 */
export async function ensureCurrentUser(): Promise<void> {
  const auth = useAuthStore()
  if (!auth.isAuthenticated) return

  auth.setUser(
    await queryClient.ensureQueryData({ queryKey: CURRENT_USER_QUERY_KEY, queryFn: getMe }),
  )
}
